import { createContext } from "react"

export const initialState = {
    selectedNetworkYearlyStatus: null,
}

const initialDispatch = {}

export const SpeedingsStateContext = createContext(initialState)
export const SpeedingsDispatchContext = createContext(initialDispatch)